{
  "admission": "Kemasukan",
  "transfer": "Pindah",
  "visit": "Lawatan",
  "type": "Jenis Lawatan",
  "status": "Status",
  "location": "Lokasi",
  "attendingPhysician": "Doktor yang Merawat",
  "admitDate": "Tarikh Kemasukan",
  "dischargeDate": "Tarikh Discaj",
  "chiefComplaint": "Keluhan Utama",
  "diagnosis": "Diagnosis",
  "class": {
    "label": "Kelas",
    "values": {
      "emergency": "Kecemasan",
      "inpatient": "Pesakit Dalam",
      "outpatient": "Pesakit Luar",
      "observation": "Pemerhatian",
      "ambulatory": "Rawatan Sehari",
      "homeHealth": "Penjagaan di Rumah",
      "virtual": "Teleperundingan"
    }
  },
  "statusValues": {
    "label": "Status",
    "values": {
      "pending": "Menunggu",
      "arrived": "Sudah Tiba",
      "active": "Sedang Berjalan",
      "completed": "Selesai",
      "cancelled": "Dibatalkan"
    }
  },
  "admissionSource": {
    "label": "Sumber Kemasukan",
    "none": "—",
    "values": {
      "emergency": "Jabatan Kecemasan",
      "clinicReferral": "Rujukan Klinik",
      "physicianReferral": "Rujukan Doktor",
      "transfer": "Pindah dari Fasiliti Lain",
      "self": "Datang Sendiri / Berjalan Masuk",
      "courtLaw": "Mahkamah / Penguatkuasa Undang-undang"
    }
  },
  "admissionType": {
    "label": "Jenis Kemasukan",
    "none": "—",
    "values": {
      "elective": "Elektif",
      "emergency": "Kecemasan",
      "urgent": "Segera",
      "newborn": "Bayi Baru Lahir",
      "trauma": "Trauma"
    }
  },
  "acuity": {
    "label": "Tahap Keperitan",
    "none": "—",
    "values": {
      "1": "1 — Resusitasi",
      "2": "2 — Tenat",
      "3": "3 — Segera",
      "4": "4 — Kurang Segera",
      "5": "5 — Tidak Segera"
    },
    "shortValues": {
      "1": "Resusitasi",
      "2": "Tenat",
      "3": "Segera",
      "4": "Kurang Segera",
      "5": "Tidak Segera"
    },
    "esiBadge": "ESI {{level}} - {{label}}"
  },
  "form": {
    "title": "Lawatan Baharu",
    "subtitle": "Mulakan lawatan / kemasukan baharu untuk pesakit ini.",
    "sections": {
      "visit": "Maklumat Lawatan",
      "reasonForVisit": "Sebab Lawatan",
      "admission": "Maklumat Kemasukan"
    },
    "fields": {
      "facility": "Fasiliti",
      "encounterClass": "Kelas Lawatan",
      "encounterType": "Jenis Lawatan",
      "department": "Jabatan",
      "attendingProvider": "Doktor yang Merawat",
      "acuity": "Tahap Keperitan",
      "visitReason": "Sebab Lawatan",
      "chiefComplaint": "Keluhan Utama",
      "admissionSource": "Sumber Kemasukan",
      "admissionType": "Jenis Kemasukan"
    },
    "placeholders": {
      "selectFacility": "Pilih fasiliti",
      "none": "—",
      "encounterType": "cth. Pemeriksaan Tahunan, Lawatan ER",
      "visitReason": "Label ringkas, cth. Susulan, Pemeriksaan Tahunan",
      "chiefComplaint": "Sebab yang dinyatakan pesakit dalam perkataannya sendiri"
    },
    "providerFallback": "Doktor #{{id}}",
    "submit": "Cipta Lawatan",
    "validation": {
      "facilityRequired": "Fasiliti diperlukan",
      "encounterClassRequired": "Kelas lawatan diperlukan"
    },
    "createdSuccess": "Lawatan dicipta",
    "createError": "Gagal mencipta lawatan"
  },
  "detail": {
    "loading": "Memuatkan lawatan...",
    "notFound": "Lawatan tidak dijumpai",
    "loadError": "Gagal memuatkan pertemuan",
    "retry": "Cuba lagi",
    "returnToDashboard": "Kembali ke Papan Pemuka",
    "header": {
      "title": "Lawatan {{number}}",
      "facilityLabel": "Fasiliti #{{id}}",
      "departmentLabel": "Jabatan #{{id}}",
      "locationLabel": "Lokasi #{{id}}",
      "admittedLabel": "Kemasukan: {{datetime}}"
    },
    "actions": {
      "transfer": "Pindah",
      "discharge": "Discaj"
    },
    "tabs": {
      "overview": "Gambaran Keseluruhan",
      "orders": "Arahan",
      "results": "Keputusan",
      "medications": "Ubat",
      "notes": "Nota",
      "billing": "Bil"
    },
    "overview": {
      "chiefComplaint": "Keluhan Utama",
      "visitReason": "Sebab Lawatan",
      "attendingProvider": "Doktor yang Merawat",
      "acuityLevel": "Tahap Keperitan",
      "providerFallback": "Doktor #{{id}}",
      "empty": "--"
    },
    "timeline": {
      "title": "Garis Masa Peristiwa",
      "empty": "Belum ada peristiwa direkodkan",
      "admittedTitle": "Kemasukan",
      "admittedDescription": "{{class}} - {{chiefComplaint}}",
      "noChiefComplaint": "Tiada keluhan utama",
      "orderTitle": "Arahan: {{name}}",
      "orderDescription": "{{type}} - {{priority}} - {{status}}",
      "resultTitle": "Keputusan: {{type}}"
    },
    "orders": {
      "title": "Arahan",
      "newOrder": "+ Arahan Baharu",
      "empty": "Tiada arahan untuk lawatan ini",
      "metaLine": "{{number}} | {{type}} | Keutamaan: {{priority}}"
    },
    "results": {
      "title": "Keputusan",
      "empty": "Tiada keputusan untuk lawatan ini",
      "criticalBadge": "KRITIKAL",
      "viewLink": "Lihat",
      "metaLine": "{{number}} | {{status}}"
    },
    "medications": {
      "title": "Ubat",
      "newMedication": "+ Ubat Baharu",
      "empty": "Tiada ubat untuk lawatan ini",
      "prnBadge": "PRN",
      "prnWithIndication": "PRN: {{indication}}"
    },
    "notes": {
      "comingSoon": "Modul nota klinikal akan datang",
      "goToClinicalNotes": "Pergi ke Nota Klinikal"
    },
    "billing": {
      "comingSoon": "Modul pembilangan akan datang"
    }
  },
  "census": {
    "title": "Papan Katil / Senarai Pesakit",
    "subtitle": "Kadar penggunaan katil dan senarai pesakit secara masa nyata",
    "refresh": "Muat Semula",
    "facilityName": "Hospital Umum Singapura",
    "capacitySummary": "{{occupied}} digunakan / {{total}} jumlah katil",
    "occupancyLabel": "{{percent}}% kadar penggunaan",
    "stats": {
      "totalCapacity": "Jumlah Kapasiti",
      "occupied": "Digunakan",
      "available": "Tersedia",
      "pendingDischarge": "Menunggu Discaj"
    },
    "unitFilter": {
      "all": "Semua Unit",
      "er": "ER",
      "icu": "ICU",
      "medsurg": "Perubatan/Pembedahan",
      "obs": "Pemerhatian",
      "peds": "Pediatrik",
      "maternity": "Bersalin"
    },
    "roleView": {
      "nurse": "Paparan Jururawat",
      "physician": "Paparan Doktor",
      "bedManager": "Paparan Pengurus Katil"
    },
    "viewMode": {
      "grid": "Paparan Grid",
      "table": "Paparan Jadual"
    },
    "loading": "Memuatkan data senarai pesakit...",
    "columns": {
      "patient": "Pesakit",
      "mrn": "MRN",
      "admitDate": "Tarikh Kemasukan",
      "status": "Status",
      "acuity": "Tahap Keperitan",
      "isolation": "Pengasingan",
      "fallRisk": "Risiko Jatuh",
      "codeStatus": "Status Resusitasi",
      "chiefComplaint": "Keluhan Utama",
      "attending": "Doktor Merawat",
      "los": "LOS",
      "locationBed": "Lokasi / Katil",
      "transferStatus": "Status Pindah",
      "expectedDischarge": "Discaj Dijangka",
      "actions": "Tindakan"
    },
    "values": {
      "unknownPatient": "Tidak Diketahui",
      "none": "Tiada",
      "notAvailable": "N/A",
      "pending": "Menunggu",
      "empty": "--",
      "providerFallback": "Doktor #{{id}}",
      "locationLabel": "Lokasi #{{id}}",
      "losDays": "{{days}} hari"
    },
    "codeStatusTooltip": "Status resusitasi tersedia di carta pesakit",
    "actionsMenu": {
      "label": "Tindakan",
      "viewChart": "Lihat Carta",
      "transfer": "Pindah",
      "assignAttending": "Tetapkan Doktor yang Merawat",
      "discharge": "Discaj"
    },
    "empty": "Tiada lawatan aktif dijumpai",
    "department": {
      "filteredTo": "Memaparkan {{name}} sahaja",
      "idLabel": "Jabatan {{id}}",
      "showAll": "Papar semua jabatan"
    },
    "facility": {
      "label": "Kemudahan",
      "allFacilities": "Semua Kemudahan",
      "idLabel": "Kemudahan {{id}}"
    }
  },
  "discharge": {
    "label": "Discaj",
    "title": "Aliran Kerja Discaj",
    "encounterLabel": "Lawatan {{number}}",
    "printButton": "Cetak Discaj",
    "loading": "Memuatkan lawatan...",
    "notFound": "Lawatan tidak dijumpai",
    "returnToDashboard": "Kembali ke Papan Pemuka",
    "notActive": "Lawatan ini tidak aktif (status: {{status}})",
    "backToEncounter": "Kembali ke Lawatan",
    "progress": {
      "requiredMissingTooltip": "Medan wajib belum diisi",
      "tasksRemainingTooltip": "Masih ada tugas tertangguh"
    },
    "steps": {
      "summary": "Ringkasan Discaj",
      "medications": "Ubat",
      "followup": "Susulan",
      "instructions": "Arahan",
      "nursing": "Tugas Kejururawatan",
      "signoff": "Tandatangan Pakar Bertanggungjawab",
      "review": "Semak & Sahkan"
    },
    "summary": {
      "title": "Ringkasan Discaj",
      "diagnosisLabel": "Diagnosis Discaj *",
      "diagnosisPlaceholder": "Masukkan diagnosis discaj...",
      "diagnosisCodeLabel": "Kod Diagnosis Discaj (ICD-10)",
      "diagnosisCodePlaceholder": "Cari kod ICD-10...",
      "proceduresLabel": "Prosedur yang Dilakukan",
      "proceduresPlaceholder": "Senaraikan prosedur yang dilakukan semasa lawatan ini...",
      "conditionLabel": "Keadaan Semasa Discaj *"
    },
    "condition": {
      "values": {
        "stable": "Stabil",
        "improved": "Bertambah Baik",
        "unchanged": "Tidak Berubah",
        "worsened": "Bertambah Buruk",
        "critical": "Kritikal"
      }
    },
    "medications": {
      "title": "Ubat Discaj",
      "instructions": "Semak setiap ubat dan pilih untuk teruskan, hentikan atau ubah suai semasa discaj.",
      "actions": {
        "continue": "Teruskan",
        "stop": "Hentikan",
        "modify": "Ubah Suai"
      },
      "modifiedPlaceholder": "Masukkan arahan yang diubah suai...",
      "empty": "Tiada ubat aktif untuk lawatan ini"
    },
    "medAction": {
      "values": {
        "continue": "teruskan",
        "stop": "hentikan",
        "modify": "ubah suai"
      }
    },
    "followup": {
      "title": "Janji Temu Susulan",
      "providerLabel": "Doktor Susulan",
      "providerPlaceholder": "Nama doktor atau pakar...",
      "dateLabel": "Tarikh Susulan",
      "notesLabel": "Nota Tambahan",
      "notesPlaceholder": "Sebarang nota tambahan untuk susulan..."
    },
    "instructions": {
      "title": "Arahan untuk Pesakit",
      "generalLabel": "Arahan Umum",
      "generalPlaceholder": "Arahan discaj umum untuk pesakit...",
      "dietaryLabel": "Arahan Pemakanan",
      "dietaryPlaceholder": "Sekatan atau cadangan diet...",
      "activityLabel": "Sekatan Aktiviti",
      "activityPlaceholder": "Sekatan aktiviti fizikal...",
      "warningSignsLabel": "Tanda Amaran untuk Diperhatikan",
      "warningSignsPlaceholder": "Simptom yang mendorong pesakit kembali atau mendapatkan rawatan..."
    },
    "nursing": {
      "title": "Tugas Kejururawatan",
      "instructions": "Lengkapkan senarai semak berikut sebelum discaj. Tugas ini hanya untuk rekod dan tidak memanggil API.",
      "tasks": {
        "removeIv": "Tanggalkan akses IV",
        "discontinueMonitoring": "Hentikan peralatan pemantauan",
        "patientEducation": "Pendidikan pesakit selesai",
        "medsReviewed": "Ubat discaj telah disemak bersama pesakit",
        "belongingsReturned": "Barangan peribadi telah dipulangkan",
        "transportArranged": "Pengangkutan telah diatur"
      }
    },
    "signoff": {
      "title": "Tandatangan Pakar Bertanggungjawab",
      "instructions": "Semak ringkasan discaj di bawah dan dapatkan tandatangan pakar bertanggungjawab.",
      "diagnosisHeading": "Diagnosis Discaj",
      "notProvided": "Tidak diisi",
      "medicationsHeading": "Ubat Discaj",
      "noMedications": "Tiada ubat untuk diselaraskan",
      "signedCompleted": "Tandatangan pakar bertanggungjawab selesai.",
      "signAsAttending": "Tandatangan sebagai Pakar Bertanggungjawab",
      "requiresAttendingSignoff": "Memerlukan tandatangan pakar bertanggungjawab"
    },
    "review": {
      "title": "Semak & Sahkan Discaj",
      "summaryHeading": "Ringkasan Discaj",
      "fields": {
        "diagnosis": "Diagnosis:",
        "procedures": "Prosedur:",
        "condition": "Keadaan:",
        "provider": "Doktor:",
        "date": "Tarikh:",
        "notes": "Nota:",
        "general": "Umum:",
        "diet": "Diet:",
        "activity": "Aktiviti:",
        "warningSigns": "Tanda Amaran:"
      },
      "medicationsHeading": "Penyelarasan Ubat",
      "noMedications": "Tiada ubat untuk diselaraskan",
      "followupHeading": "Susulan",
      "instructionsHeading": "Arahan untuk Pesakit",
      "noInstructions": "Tiada arahan diberikan",
      "pendingOrdersWarning": "Mungkin terdapat arahan tertangguh atau nota tidak ditandatangani. Sila sahkan sebelum menyelesaikan discaj.",
      "diagnosisRequired": "Diagnosis discaj diperlukan sebelum menyelesaikan discaj.",
      "empty": "--"
    },
    "nav": {
      "previous": "Sebelumnya",
      "next": "Seterusnya",
      "complete": "Selesaikan Discaj"
    },
    "toast": {
      "success": "Pesakit berjaya didiscajkan",
      "error": "Gagal menyelesaikan discaj"
    }
  },
  "components": {
    "transferDialog": {
      "title": "Pindah Pertemuan",
      "description": "Pindahkan pesakit ke lokasi lain dalam kemudahan ini.",
      "targetLocationLabel": "Lokasi Sasaran",
      "loadingLocations": "Memuatkan lokasi…",
      "selectLocation": "Pilih lokasi",
      "emptyState": "Tiada lokasi aktif lain dalam kemudahan ini.",
      "reasonLabel": "Sebab",
      "reasonPlaceholder": "cth. pengasingan diperlukan, turun aras ICU, katil pemerhatian lebih tinggi",
      "actions": {
        "transfer": "Pindah"
      },
      "toasts": {
        "success": "Pertemuan telah dipindahkan",
        "error": "Gagal memindahkan pertemuan"
      }
    },
    "assignAttendingDialog": {
      "title": "Tetapkan Doktor yang Merawat",
      "description": "Tetapkan doktor yang merawat untuk pertemuan ini.",
      "providerLabel": "Doktor yang Merawat",
      "loadingProviders": "Memuatkan doktor…",
      "selectProvider": "Pilih doktor",
      "emptyState": "Tiada doktor aktif di fasiliti ini.",
      "actions": {
        "assign": "Tetapkan"
      },
      "toasts": {
        "success": "Doktor yang merawat ditetapkan",
        "error": "Tidak dapat menetapkan doktor yang merawat"
      }
    },
    "bedBoard": {
      "bedStatus": {
        "available": "Tersedia",
        "occupied": "Diduduki",
        "reserved": "Disimpan",
        "cleaning": "Dibersihkan",
        "closed": "Ditutup",
        "isolated": "Pengasingan",
        "contaminated": "Tercemar"
      },
      "acuityLegendLabel": "Akuiti ESI:",
      "empty": "Tiada unit dikonfigurasi",
      "summary": {
        "available_one": "{{count}} tersedia",
        "available_other": "{{count}} tersedia",
        "occupied_one": "{{count}} diduduki",
        "occupied_other": "{{count}} diduduki",
        "reserved_one": "{{count}} disimpan",
        "reserved_other": "{{count}} disimpan",
        "cleaning_one": "{{count}} dibersihkan",
        "cleaning_other": "{{count}} dibersihkan",
        "closed_one": "{{count}} ditutup",
        "closed_other": "{{count}} ditutup",
        "isolated_one": "{{count}} pengasingan",
        "isolated_other": "{{count}} pengasingan",
        "contaminated_one": "{{count}} tercemar",
        "contaminated_other": "{{count}} tercemar"
      }
    },
    "protocolPanel": {
      "title": "Pendaftaran Protokol",
      "enroll": "Daftar",
      "availableProtocols": "Protokol Tersedia",
      "loadingProtocols": "Memuatkan protokol...",
      "noProtocols": "Tiada protokol tersedia",
      "stepBadge": "Langkah {{current}}/{{total}}",
      "loadingEnrollments": "Memuatkan pendaftaran...",
      "noEnrollments": "Tiada pendaftaran protokol aktif",
      "completeStep": "Lengkapkan Langkah",
      "toasts": {
        "enrollSuccess": "Didaftarkan dalam protokol",
        "enrollError": "Gagal mendaftar protokol",
        "advanceSuccess": "Langkah selesai",
        "advanceError": "Gagal meneruskan langkah"
      }
    }
  }
}
